import React, { useEffect } from "react";
import "./user-setting.css";
import { useNavigate } from "react-router-dom";
import { Avatar, Form, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import LilyButton from "../../../../components/button/lily-button";
import { useSelector } from "react-redux";
import { formatAddress, formatGender, parseDob } from "../../../../exports/util";
import moment from "moment";
import BackButton from "../../../../components/button/back-button";
import CopyInfoComponent from "../../../../components/copay-info.component";

const UserSettingPage = () => {
  const user = useSelector((state) => state.authenticatedUser);
  const { Title, Text } = Typography;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    let entityData = {
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      email: user?.email || "",
      phone: user?.phone?.number || "",
    };

    form.setFieldsValue(entityData);
  }, [user, form]);

  const filledDetails = (data) => {
    let fields = [
      {
        title: "Copay Card Member ID#",
        element: (
          <Text style={{ fontSize: "16px" }}>{data?.memberId || "N/A"}</Text>
        ),
      },
      {
        title: "Date of Birth",
        element: (
          <Text style={{ fontSize: "16px" }}>
            {data?.dob ? parseDob(data?.dob).format("MM/DD/YYYY") : "N/A"}
          </Text>
        ),
      },
      {
        title: "Gender",
        element: (
          <Text style={{ fontSize: "16px" }}>
            {data?.gender ? formatGender[data.gender] : "N/A"}
          </Text>
        ),
      },
      {
        title: "Address",
        element: (
          <Text style={{ fontSize: "16px" }}>
            {formatAddress({
              line1: data?.address?.line1 || "",
              line2: data?.address?.line2 || "",
              city: data?.address?.city || "",
              state: data?.address?.state || "",
              zip: data?.address?.zip || "",
            })}
          </Text>
        ),
      },
      {
        className: "d-flex flex-column gap-2",
        title: "Copay Card Processing Information",
        element: (
          <CopyInfoComponent data={data} textStyle={{ fontSize: "16px" }} />
        ),
      },
      {
        className: "d-flex flex-row gap-2",
        title: "Participating Program",
        element: (
          <Text style={{ fontSize: "16px" }}>
            {data?.copayCardInfo?.programName || "N/A"}
          </Text>
        ),
      },
    ];
    return fields;
  };

  return (
    <div className="user-setting-layout">
      <div className="w-100">
        <BackButton path="/dashboard" />
      </div>
      <div className="w-100 d-flex justify-content-center mt-4">
        <div className="user-info gap-3">
          <div className="d-flex flex-column align-items-center gap-3">
            <Avatar size={64} icon={<UserOutlined />} />
            <div className="d-flex flex-column align-items-center">
              <Title
                style={{ fontSize: "24px" }}
                className="mb-0 main-title"
                level={5}
              >
                {user?.fullName || ""}
              </Title>
              <Text style={{ fontSize: "16px" }}>{user?.email || ""}</Text>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex flex-column gap-1 px-3">
              {filledDetails(user).map((item) => {
                return (
                  <div
                    className={`${item.className || "d-flex flex-row gap-2"}`}
                  >
                    <Text style={{ fontSize: "16px" }} strong>
                      {item.title}:
                    </Text>
                    {item.element}
                  </div>
                );
              })}
              <div className="d-flex flex-row gap-2 mt-3">
                <Text style={{ fontSize: "16px" }} strong>
                  For any changes to your personal information, please reach out
                  to our team for support.
                </Text>
              </div>
              <div className="d-flex flex-row gap-2">
                <LilyButton
                  className="mt-2"
                  onClick={() => navigate("/contact-us")}
                  text="Contact Us"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettingPage;
